import Button from 'epn-ui/umd/dist/components/Button';

// Helpers
import useI18n from '@i18n';

export interface IEmptyDialogsProps {
    onAskQuesiton: (state: boolean) => void;
}

const EmptyDialogs: React.FC<IEmptyDialogsProps> = ({ onAskQuesiton }) => {
    const { t } = useI18n('Support');

    return (
        <div className="flex flex-col justify-center p-8 -m-4 bg-blueGray-100 rounded-2">
            <div className="mb-4 text-blueGray-500 text-p2">{t('Create your question')}</div>
            <div>
                <Button className="mt-4 xs:mt-0" type="primary" onClick={() => onAskQuesiton(true)}>
                    {t('Ask question')}
                </Button>
            </div>
        </div>
    );
};

export default EmptyDialogs;
